export const setIsLoading = (isLoading) => {
    return {
      type: 'SET_LOADING',
      payload: isLoading
    };
  };
  
  export const setProcessingState = (state) => {
    return {
      type: 'SET_PROCESSING_STATE',
      payload: state
    };
  };
  
  export const setViralClips = (clips) => {
    return {
      type: 'SET_VIRAL_CLIPS',
      payload: clips
    };
  };
  
  export const clearVideoState = () => {
    return {
      type: 'CLEAR_VIDEO_STATE'
    };
  };
  